import { http } from '../lib/api/http';

const BASE_PATH = '/promotions';

const mapPromotion = record => {
  if (!record) return null;
  return {
    id: record.id,
    resourceType: record.resource_type || record.resourceType || '',
    resourceId: record.resource_id || record.resourceId || '',
  };
};

export async function listPromotions({ resourceType, resourceId } = {}) {
  const params = {};
  if (resourceType) {
    params.resource_type = resourceType;
  }
  if (resourceId) {
    params.resource_id = resourceId;
  }
  const response = await http.get(BASE_PATH, { params });
  const items = Array.isArray(response.data) ? response.data : [];
  return items.map(mapPromotion).filter(Boolean);
}

export async function promoteResource(resourceType, resourceId) {
  if (!resourceType || !resourceId) {
    throw new Error('El recurso a promocionar es invalido.');
  }
  const payload = {
    resource_type: resourceType,
    resource_id: resourceId,
  };
  const response = await http.post(BASE_PATH, payload);
  return mapPromotion(response.data);
}

export async function removePromotion(promotionId) {
  if (!promotionId) return false;
  await http.delete(`${BASE_PATH}/${encodeURIComponent(promotionId)}`);
  return true;
}

export async function unpromoteResource(resourceType, resourceId) {
  if (!resourceType || !resourceId) return false;
  const matches = await listPromotions({ resourceType, resourceId });
  if (!matches.length) return false;
  await removePromotion(matches[0].id);
  return true;
}
